import { useEffect, useRef } from 'react';
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { toastActions } from '@/store/slices/toastSlice';

/** creditAvailable이 true → false로 전환될 때 전역 SNSnackbar로 알림 */
export function useTranslationCreditNotice() {
  const dispatch = useAppDispatch();
  const creditAvailable = useAppSelector((s) => s.translation.creditAvailable);
  const prevRef = useRef(creditAvailable);

  useEffect(() => {
    if (prevRef.current && !creditAvailable) {
      dispatch(
        toastActions.showSnackbar({
          type: 'error',
          message: 'Credit이 모두 소진되어 번역이 중지되었습니다.',
        }),
      );
    }
    prevRef.current = creditAvailable;
  }, [creditAvailable, dispatch]);
}
